import { configureStore } from "@reduxjs/toolkit";
import sidebarsReducers from "./slice/Sidebars";
import ipoViewReducers from "./slice/IpoView";
import appDataReducers from "./slice/AppData";
import searchDataReducers from "./slice/SearchData";
import { defaultFrontOfficeReduxReducers } from "@duosoftbg/nacid-frontoffice-components";
import requestReducers from "./slice/Request";

export const store = configureStore({
  reducer: {
    ...defaultFrontOfficeReduxReducers,
    Sidebars: sidebarsReducers,
    IpoView: ipoViewReducers,
    AppData: appDataReducers,
    SearchData: searchDataReducers,
    Request: requestReducers,
  },
  devTools: process.env.REACT_APP_PROFILE !== "production",
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
